import React, { Component, useMemo } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import AssignmentSelect from './renderAssignmentSelect';
import loadingGif from '../../assets/img/loading-pinwheel.gif';
import '../../assets/css/components/assignment-form.css';
import { useForm, useField } from 'react-form';
import { buildStudentGroupings } from '../../util'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function AssignmentSelectField(props) {
    const { meta: {error, isTouched, isValidating }, getInputProps, setValue, value } = useField(props.name)
  return <AssignmentSelect fieldValue={value} {...props} input={{id: props.name, name: props.name}}/>
}

const BulkAssignmentDeletionForm = ({ studentGroupings, assignableContent, fetchedRequestId, isFetching, isDeleting, deleteErrors, deletedAssignments, onSubmit, defaultAssignees, getSuccessMessage, onAssigneeChange }) => {

  const getDeleteMessage =(errorMessage)=>{
    let deleteError = _.isArray(errorMessage) ? errorMessage[0] : errorMessage
    deleteError = _.isString(deleteError) ? deleteError : deleteError.message
    return deleteError
  }

  const getDefaultValues = { studentGroupings: (_.isEmpty(defaultAssignees) ? [] : defaultAssignees)}

  const { Form, values, setFieldValue }= useForm({
    onSubmit: (values, instance)=>onSubmit(values),
    defaultValues: useMemo(()=>getDefaultValues, [])
  })

  return(
    <Form className='assignment-form'>
      <AssignmentSelectField
        name='studentGroupings'
        label='From Students or Classes'
        multiple
        data={buildStudentGroupings(studentGroupings)}
        updateValue={setFieldValue}
        onAssigneeChange={onAssigneeChange}
      />
      <div className="card-block">
        <div className='form-results'>
          { (!_.isEmpty(deletedAssignments)) &&
          <div className='success-container'><FontAwesomeIcon icon='check-circle' color='#4FCA15' /><div className='form-success'>{getSuccessMessage(deletedAssignments)}</div></div>
          }
          {!_.isEmpty(deleteErrors) && <span className='error'>{getDeleteMessage(deleteErrors)}</span>}
        </div>
        <div className='submit-container'>
          <button type='submit' disabled={isDeleting || isFetching} className='btn btn-primary btn-submit'>Delete</button>
          <img className={`loading-gif ${(isDeleting || isFetching) ? '' : 'hidden'}`} src={loadingGif}/>
        </div>
      </div>
    </Form>
  );
}

const { object, array } = PropTypes
BulkAssignmentDeletionForm.propTypes = {
  deletableContent: object.isRequired,
  studentGroupings: array.isRequired
}

export default BulkAssignmentDeletionForm;
